import Module from '@/store/resource/common/module';
import FormSubmissions from '@/store/resource/formSubmissions';
import api from '@/factories/api';

let module = new Module(new FormSubmissions());

module.add('actions', {
  async createSubmissionCollection({ commit }, payload) {
    try {
      return await api().post('form/submission_collections', payload);
    } catch (error) {
      throw error;
    }
  },
});

export default module.create();
